import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './pages/Home';
import Studio from './pages/Studio';
import Analytics from './pages/Analytics';
import HeatmapViewer from './pages/HeatmapViewer';
import { useAnalyticsTracker } from './utils/Hooks/useAnalyticsTracker';

function getRouteFromHash() {
  const hash = window.location.hash || '#/';

  if (hash.startsWith('#/analytics/heatmap')) {
    return 'analytics-heatmap';
  }

  if (hash.startsWith('#/studio')) {
    return 'studio';
  }

  if (hash.startsWith('#/analytics')) {
    return 'analytics';
  }

  return 'home';
}

function isPreviewHash() {
  return (window.location.hash || '').includes('analytics-preview=1');
}

function getPreviewDeviceFromHash() {
  const hash = window.location.hash || '';

  if (hash.includes('analytics-device=mobile')) {
    return 'mobile';
  }

  return 'desktop';
}

function isHeatmapRenderHash() {
  return (window.location.hash || '').includes('analytics-heatmap=1');
}

function AppRouter() {
  const [route, setRoute] = useState(getRouteFromHash());
  const [previewMode, setPreviewMode] = useState(isPreviewHash());
  const [previewDevice, setPreviewDevice] = useState(getPreviewDeviceFromHash());
  const [heatmapRenderMode, setHeatmapRenderMode] = useState(isHeatmapRenderHash());
  useAnalyticsTracker(route, { enabled: !previewMode && !heatmapRenderMode && route === 'home' });

  useEffect(() => {
    const onHashChange = () => {
      setRoute(getRouteFromHash());
      setPreviewMode(isPreviewHash());
      setPreviewDevice(getPreviewDeviceFromHash());
      setHeatmapRenderMode(isHeatmapRenderHash());

      if (!isPreviewHash()) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  if (route === 'studio') {
    return <Studio previewMode={previewMode} previewDevice={previewDevice} />;
  }

  if (route === 'analytics-heatmap') {
    return <HeatmapViewer />;
  }

  if (route === 'analytics') {
    return <Analytics />;
  }

  return <Home heatmapRenderMode={heatmapRenderMode} previewDevice={previewDevice} previewMode={previewMode} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
